import { ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { cva } from "class-variance-authority"

// https://www.youtube.com/watch?v=wg3c1Q2nzUQ
// This function takes in clsx style classnames as input, produces a tailwind css util string as it's output.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export function classVariantsAuthority(
  defaults: string | string[],
  variance: any,
) {
  return cva(defaults, variance)
}

export default cn
